import type { Game } from '../services/games';

export function generateGameDescription(game: Game): string {
    if (game.description && game.description.trim() !== '') {
        return game.description;
    }
    return `Experience the excitement of ${game.name}. Play now and discover amazing features and big wins!`;
}
